import { html } from 'lit-element'
import { singleSpaLit } from '../../../common'
import { GOTO_BANNER_NOTIFICATION_SELECTOR } from '../../../common/container'

const lifecycles = singleSpaLit({
  template: () => html`<goto-banner-notification></goto-banner-notification>`,
  domElement: GOTO_BANNER_NOTIFICATION_SELECTOR,
})

export default lifecycles
